import type { ReactNode } from "react";
import { Button } from "@mui/material";
import type { SxProps } from "@mui/material";
import type { ColorPaletteKey } from "providers";

type StatutButtonProps = {
  checked: boolean;
  onClick: () => void;
  label: string | ReactNode;
  color?: ColorPaletteKey;
  sx?: SxProps;
  disabled?: boolean;
};
function StatutButton({
  onClick,
  color,
  checked,
  label,
  sx,
  disabled = false,
}: Readonly<StatutButtonProps>): ReactNode {
  return (
    <Button
      variant={checked ? "contained" : "outlined"}
      onClick={onClick}
      sx={sx}
      color={color}
      disabled={disabled}>
      {label}
    </Button>
  );
}

export default StatutButton;
